import { Box, styled, Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";

const StickyBox = styled(Box)({
  position: "fixed",
  left: "50%",
  transform: "translateX(-50%)",
  backgroundColor: "white",
  padding: "16px 16px 16px 64px",
  zIndex: 1,
  textAlign: "left",
  width: "100%",
  maxWidth: "1200px",
  borderRight: "2px solid rgba(224, 224, 224, 1)",
});

export function EmptyRegisterMessage() {
  return (
    <StickyBox>
      <Typography variant="subtitle1">
        <FormattedMessage
          id="register.empty"
          defaultMessage="There is no patient information for the selected date range"
        />
      </Typography>
    </StickyBox>
  );
}

export function LoadingRegisterMessage() {
  return (
    <Box>
      <Typography variant="subtitle1">
        <FormattedMessage
          id="register.loading"
          defaultMessage="Fetching Patient Register..."
        />
      </Typography>
    </Box>
  );
}
